import React from 'react'

interface IProps {
  reset: () => void
}

export default function Error500(props: IProps): React.ReactElement {
    return (
        <div>
            Error 500
            <button onClick={props.reset}>Voltar</button>
        </div>
    )
}